import React from "react";
// NAVIGATION
import { useNavigate } from "react-router-dom";
// ANT DESIGN COMPONENTS
import { Breadcrumb } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

export default function BankActionsBreadcrumb() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");
	const navigate = useNavigate();

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickBank = () => {
		navigate({
			pathname: "/edge-management/banks",
		});
	};
	// ************************************************* */
	// USE EFFECT ************************************** */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Breadcrumb className=''>
			<Breadcrumb.Item>{t("header.edgeManagement")}</Breadcrumb.Item>
			<Breadcrumb.Item className='generalStyles__breadcrumbItemInactive' onClick={onClickBank}>
				{t("header.banks")}
			</Breadcrumb.Item>
			<Breadcrumb.Item className='generalStyles__breadcrumbItem'>Actions</Breadcrumb.Item>{" "}
		</Breadcrumb>
	);
}
